import { Observable } from 'rxjs/Rx';
import { ConfirmDialog } from './confirm-dialog.component';
import { InfoDialog } from './info-dialog.component';
import { CustomConfirmDialogComponent } from './app-custom-confirm-dialog.component';
import { MdDialogRef, MdDialog, MdDialogConfig } from '@angular/material';
import { Injectable } from '@angular/core';

@Injectable()
export class DialogsService {

  constructor(private dialog: MdDialog) { }

  public confirm(title: string, message: string): Observable<boolean> {

    let dialogRef: MdDialogRef<ConfirmDialog>;

    dialogRef = this.dialog.open(ConfirmDialog);
    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.message = message;

    return dialogRef.afterClosed();
  }

  public customConfirm(title: string, message: string, url: string, text: string): Observable<boolean> {
    let dialogRef: MdDialogRef<CustomConfirmDialogComponent>;

    dialogRef = this.dialog.open(CustomConfirmDialogComponent);
    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.message = message;
    dialogRef.componentInstance.url = url;
    dialogRef.componentInstance.text = text;

    return dialogRef.afterClosed();
  }

  public info(title: string, message: string): Observable<boolean> {

    let dialogRef: MdDialogRef<InfoDialog>;

    dialogRef = this.dialog.open(InfoDialog);
    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.message = message;

    return dialogRef.afterClosed();
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/component/dialog/dialogs.service.ts